import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=2d4eb7bd&"
import script from "./GoogleLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleLogin.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=2d4eb7bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports